import confirm from './confirm';

function createMessage(Vue, component, options) {
  const temp = Vue.extend(component);
  const instance = new temp();
  document.body.appendChild(instance.$mount().$el);
  if (typeof options === 'string') {
    instance.content = options;
  } else if (typeof options === 'object') {
    Object.assign(instance, options);
  }
  instance.visible = true;
}

let confirmInstance;
let notifyInstance;

const notify = {
  install: function (Vue) {
    Vue.prototype.$alert = function (options) {
      if (!notifyInstance) {
        notifyInstance = createMessage(Vue, confirm, {cancelButton: {}, ...options});
      }
    };
    Vue.prototype.$confirm = function (options) {
      if (!confirmInstance) {
        confirmInstance = createMessage(Vue, confirm, options);
      }
    };
  }
};
export default notify;